var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvailability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 64.5H196",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 106.5H196",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2414 39.7537C48.2825 39.7537 46.6946 41.3416 46.6946 43.3005V43.3005C46.6946 45.2593 48.2825 46.8473 50.2414 46.8473H158.419C160.378 46.8473 161.966 45.2593 161.966 43.3005V43.3005C161.966 41.3416 160.378 39.7537 158.419 39.7537H50.2414Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2414 39.7537C48.2825 39.7537 46.6946 41.3416 46.6946 43.3005V43.3005C46.6946 45.2593 48.2825 46.8473 50.2414 46.8473H105.926C107.885 46.8473 109.473 45.2593 109.473 43.3005V43.3005C109.473 41.3416 107.885 39.7537 105.926 39.7537H50.2414Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.379 39.7537C172.42 39.7537 170.833 41.3416 170.833 43.3005V43.3005C170.833 45.2593 172.42 46.8473 174.379 46.8473H189.476C191.435 46.8473 193.023 45.2593 193.023 43.3005V43.3005C193.023 41.3416 191.435 39.7537 189.476 39.7537H174.379Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3005 56.601C33.6462 56.601 39.601 50.6462 39.601 43.3005C39.601 35.9548 33.6462 30 26.3005 30C18.9548 30 13 35.9548 13 43.3005C13 50.6462 18.9548 56.601 26.3005 56.601Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3028 47.035C30.2513 47.035 30.1998 46.9835 30.1483 46.9835V46.9835C29.3757 46.6744 28.294 46.0563 28.294 45.1806C28.294 43.8414 29.8393 43.6353 30.0453 40.9053C30.1998 38.6904 29.0151 37.0936 26.8002 37.0936C24.5853 37.0936 23.4006 38.6904 23.5551 40.9053C23.7611 43.6868 25.3064 43.8929 25.3064 45.1806C25.3064 46.0563 24.2247 46.6744 23.4521 46.9835V46.9835C23.4006 46.9835 23.3491 47.035 23.2975 47.035C22.8855 47.241 22.5764 47.7046 22.5764 48.2197C22.5764 48.9408 23.143 49.5074 23.8642 49.5074H26.8002H29.7362C30.4574 49.5074 31.024 48.9408 31.024 48.2197C31.0755 47.7046 30.7664 47.241 30.3028 47.035V47.035Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2414 81.7537C48.2825 81.7537 46.6946 83.3416 46.6946 85.3005V85.3005C46.6946 87.2593 48.2825 88.8473 50.2414 88.8473H158.419C160.378 88.8473 161.966 87.2593 161.966 85.3005V85.3005C161.966 83.3416 160.378 81.7537 158.419 81.7537H50.2414Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2414 81.7537C48.2825 81.7537 46.6946 83.3416 46.6946 85.3005V85.3005C46.6946 87.2593 48.2825 88.8473 50.2414 88.8473H141.294C143.253 88.8473 144.841 87.2593 144.841 85.3005V85.3005C144.841 83.3416 143.253 81.7537 141.294 81.7537H50.2414Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.379 81.7537C172.42 81.7537 170.833 83.3416 170.833 85.3005V85.3005C170.833 87.2593 172.42 88.8473 174.379 88.8473H189.476C191.435 88.8473 193.023 87.2593 193.023 85.3005V85.3005C193.023 83.3416 191.435 81.7537 189.476 81.7537H174.379Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3005 98.601C33.6462 98.601 39.601 92.6462 39.601 85.3005C39.601 77.9548 33.6462 72 26.3005 72C18.9548 72 13 77.9548 13 85.3005C13 92.6462 18.9548 98.601 26.3005 98.601Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3028 89.035C30.2513 89.035 30.1998 88.9835 30.1483 88.9835V88.9835C29.3757 88.6744 28.294 88.0563 28.294 87.1806C28.294 85.8414 29.8393 85.6353 30.0453 82.9053C30.1998 80.6904 29.0151 79.0936 26.8002 79.0936C24.5853 79.0936 23.4006 80.6904 23.5551 82.9053C23.7611 85.6868 25.3064 85.8929 25.3064 87.1806C25.3064 88.0563 24.2247 88.6744 23.4521 88.9835V88.9835C23.4006 88.9835 23.3491 89.035 23.2975 89.035C22.8855 89.241 22.5764 89.7046 22.5764 90.2197C22.5764 90.9408 23.143 91.5074 23.8642 91.5074H26.8002H29.7362C30.4574 91.5074 31.024 90.9408 31.024 90.2197C31.0755 89.7046 30.7664 89.241 30.3028 89.035V89.035Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2414 123.754C48.2825 123.754 46.6946 125.342 46.6946 127.3V127.3C46.6946 129.259 48.2825 130.847 50.2414 130.847H158.419C160.378 130.847 161.966 129.259 161.966 127.3V127.3C161.966 125.342 160.378 123.754 158.419 123.754H50.2414Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2414 123.754C48.2825 123.754 46.6946 125.342 46.6946 127.3V127.3C46.6946 129.259 48.2825 130.847 50.2414 130.847H75.8632C77.8221 130.847 79.41 129.259 79.41 127.3V127.3C79.41 125.342 77.8221 123.754 75.8632 123.754H50.2414Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.379 123.754C172.42 123.754 170.833 125.342 170.833 127.3V127.3C170.833 129.259 172.42 130.847 174.379 130.847H189.476C191.435 130.847 193.023 129.259 193.023 127.3V127.3C193.023 125.342 191.435 123.754 189.476 123.754H174.379Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3005 140.601C33.6462 140.601 39.601 134.646 39.601 127.3C39.601 119.955 33.6462 114 26.3005 114C18.9548 114 13 119.955 13 127.3C13 134.646 18.9548 140.601 26.3005 140.601Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3028 131.035C30.2513 131.035 30.1998 130.983 30.1483 130.983V130.983C29.3757 130.674 28.294 130.056 28.294 129.181C28.294 127.841 29.8393 127.635 30.0453 124.905C30.1998 122.69 29.0151 121.094 26.8002 121.094C24.5853 121.094 23.4006 122.69 23.5551 124.905C23.7611 127.687 25.3064 127.893 25.3064 129.181C25.3064 130.056 24.2247 130.674 23.4521 130.983V130.983C23.4006 130.983 23.3491 131.035 23.2975 131.035C22.8855 131.241 22.5764 131.705 22.5764 132.22C22.5764 132.941 23.143 133.507 23.8642 133.507H26.8002H29.7362C30.4574 133.507 31.024 132.941 31.024 132.22C31.0755 131.705 30.7664 131.241 30.3028 131.035V131.035Z",
    fill: "#BBBDBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/Availability.ab459ac6993c5fc08af4c9accb37bf37.svg";
export { ForwardRef as ReactComponent };